import {createSlice} from '@reduxjs/toolkit';
import {resendSMSCodeApi} from "../../api/auth/resendSMSCodeApi";

export const resendSMSCodeSlice = createSlice({
    name: 'users',
    initialState: {
        entities: [],
        loading: 'idle',
        currentRequestId: undefined,
        errorMessage: '',
        errors: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(resendSMSCodeApi.pending, (state, action) => {
                const { requestId } = action.meta
                if (state.loading === 'idle') {
                    state.loading = 'pending'
                    state.currentRequestId === requestId
                }
            })
            .addCase(resendSMSCodeApi.fulfilled, (state, action) => {
                const {meta, payload} = action;
                const { requestId } = meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'fulfilled'
                    // @ts-ignore
                    state.entities.push(payload)
                    state.currentRequestId = undefined
                }
            })
            .addCase(resendSMSCodeApi.rejected, (state, action) => {
                state.loading = 'rejected'
            })
    },
});


export default resendSMSCodeSlice.reducer;